<template>
  <div>
    <Button
      class="feed__answersButton top-answer-button"
      :icon="shown ? 'chevronUp' : 'chevronDown'"
      is-icon
      :label_text="shown ? (answers.length === 1 ? 'Antwort verbergen' : 'Antworten verbergen') : answers.length + (answers.length === 1 ? ' Antwort anzeigen' : ' Antworten anzeigen')"
      @click.native="shown = !shown"
    />
    <div v-if="shown">
      <div v-for="postcard in answers" :key="postcard.id" class="feed__answerPostcard">
        <Answer style="position: absolute; left: -40px; top: 0; transform:rotate(180deg)"/>
        <div class="postcard-wrapper" :class="{ unApproved: !postcard.approved && !postcard.show }">
          <div
            v-if="!postcard.approved"
            class="unApproved_note"
            :class="{ 'd-none': postcard.show }"
          >
            <span v-if="postcard.hidden">Diese Postkarte wurde von der Redaktion abgelehnt!</span>
            <span v-if="!postcard.hidden">Diese Postkarte ist noch nicht freigegeben!</span>
            <br />
            <span v-if="loggedInUser != null && loggedInUser.level_of_user !== 'normal'">
              Als "{{ loggedInUser.level_of_user }}" kannst du die Postkarte
              <a @click="showPostcard(postcard)">jetzt prüfen</a>!
            </span>
          </div>

          <PostCardMobile v-if="isMobile" :postcard_info="postcard" :loggedInUser="loggedInUser" class="postcard postcard--answer"
          :class="{ 'active-style_ButtonBar': postcard.approved }"/>
          <PostCard v-else :postcard_info="postcard" :loggedInUser="loggedInUser" class="postcard" />
          <PostcardBar
            v-if="postcard.approved"
            :id="postcard.id"
            ref="postcardBar"
            v-model="postcard.isSaved"
            class="answer-button-row"
            :bookmarked="postcard.isSaved"
            :sender="postcard.sender"
            :topic="postcard.subject"
            :postcard="postcard"
            @showModal="$emit('showModal', $event)"
          />
          <!--        <PostcardBar
          v-if="postcard.approved"
          :id="postcard.id"
          ref="postcardBar"
          v-model="postcard.isSaved"
          class="button_row"
          :bookmarked="postcard.isSaved"
          :sender="postcard.sender"
          :topic="postcard.subject"
          :postcard="postcard"
          @showModal="openBookmarkModal()"
        />
        <div id="bookmarkModal" class="modal" @click="closeBookmarkModal($event)">
          <div class="modal-content">
            <span class="close" @click="closeBookmarkModal($event)"><v-icon>$x</v-icon></span>
            <p class="bookmark-modal-heading heading-three font-dark-grey">Postkarte speichern</p>
            <p class="bookmark-modal-text font-dark-grey font-medium">
              Du kannst Postkarten speichern, wenn du ein Konto angelegt hast. Möchtest du jetzt ein
              eigenes Profil erstellen?
            </p>
            <Button
              label_text="Profil erstellen"
              :is-primary="true"
              @click.native="
                $event.stopPropagation();
                $router.push('/register');
              "
            />
          </div>
        </div>-->
        </div>
      </div>
      <Button
      class="feed__answersButton bottom-answer-button"
      :icon="shown ? 'chevronUp' : 'chevronDown'"
      is-icon
      v-show="shown"
      :label_text="shown ? (answers.length === 1 ? 'Antwort verbergen' : 'Antworten verbergen') : answers.length + (answers.length === 1 ? ' Antwort anzeigen' : ' Antworten anzeigen')"
      @click.native="shown = !shown"
      style="margin-top: 0px"
    />
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button";
import { getLoggedInUser } from "@/services/loggedIn";
import PostCard from "@/components/PostCard";
import PostcardBar from "./PostcardBar";
import Answer from "@/components/Icons/Answer.vue";
import PostCardMobile from "@/components/PostCardMobile.vue";
import { useIsMobile } from "@/services/utils.js";
export default {
  name: "PostcardAnswers",
  components: { PostCard, PostCardMobile, Button, PostcardBar, Answer },
  setup() {
    const isMobile = useIsMobile();
    return { isMobile };
  },
  props: {
    answers: { type: Array },
  },
  data: () => ({
    shown: false,
  }),
  computed: {
    loggedInUser() {
      return JSON.parse(getLoggedInUser());
    },
  },
  methods: {
    showPostcard(postcard) {
      if (postcard.approved) {
        postcard.show = true;
      } else if (this.loggedInUser.level_of_user !== "normal") {
        postcard.show = true;
        postcard.readOnly = false;
      }
    },
  },
};
</script>

<style scoped></style>
